<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <v-dialog v-model="dialog.role"
          @keydown.esc="dialog.role = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Ubah Hak Akses

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.role = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Role" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Role
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Admin"

                      hide-details
                      
                      :items="role"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.role_id"
                      :success="form.role_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="roles()"
                :loading="process.role"
                :disabled="process.role"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.role = false; dialog.fullscreen = false;"
                :disabled="process.role"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/perusahaan"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Perusahaan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row>
                    <v-col cols="3">
                      <v-img
                        :src="require('@/assets/icon/store_amanata.png')"
                        height="200px"
                        contain
                        class="border-radius">
                      </v-img>
                    </v-col>
                    <v-col cols="9">
                      <div>
                        <div>
                          Nama Perusahaan
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.name }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Jenis Usaha
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.business_type }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Nama Pemilik
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.user_name }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Email Pemilik
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.user_email }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Mobilephone Pemilik
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.user_mobilephone }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Posisi Pemilik
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.user_position }}
                        </div>
                      </div>

                      <div class="mt-5">
                        <div>
                          Tanggal Daftar
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.input_datetime | datetime }}
                        </div>
                      </div>
                    </v-col>
                    
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                min-height="calc(100vh - 240px)"
                class="mt-8"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 black_one mb-5 font-weight-bold">
                    Daftar Outlet
                  </div>
                  <v-row>
                    <v-col cols="6" v-for="(item, index) in detail.outlet" :key="index">
                      <v-card>
                        <v-card-text>
                          <v-row>
                            <v-col cols="3">
                              <v-img :src="require('@/assets/icon/store_amanata.png')"></v-img>
                            </v-col>
                            <v-col cols="9">
                              <div>
                                <div>
                                  Nama Outlet
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_name }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Alamat
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_address }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Kelurahan
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_village_name }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Kecamatan
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_subdistrict_name }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Kota / Kabupaten
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_city_name }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Provinsi
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_province_name }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Status Subscribe
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_status }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Tipe Subscribe
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_subscribe_type }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Tanggal Mulai Trial
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_trial_start_date | date }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Tanggal Akhir Trial
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_trial_end_date | date }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Tanggal Mulai Subscribe
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_subscribe_start_date === null || item.outlet_subscribe_start_date === '' ? '-' : `${item.outlet_subscribe_start_date | date}` }}
                                </div>
                              </div>

                              <div class="mt-3">
                                <div>
                                  Tanggal Akhir Subscribe
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.outlet_subscribe_end_date === null || item.outlet_subscribe_end_date === '' ? '-' : `${item.outlet_subscribe_end_date | date}` }}
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <iframe 
                                width="100%" 
                                height="250" 
                                frameborder="0" 
                                scrolling="no" 
                                marginheight="0" 
                                marginwidth="0" 
                                :src="`https://maps.google.com/maps?q=${item.outlet_latitude},${item.outlet_longitude}&hl=es&z=14&amp;output=embed`"
                                >
                              </iframe>
                            </v-col>
                          </v-row>
                          <div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat>
                <v-card-actions
                  class="px-4">
                  <v-spacer/>
                  
                  <v-btn
                    to="/perusahaan"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-progress-close
                    </v-icon>

                    <span
                      class="ml-2">
                      Kembali
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          role: false
        },
        
        detail: {},

        role: [],

        list: [],

        form: {
          id: '',
          role_id: ''
        },
        
        process: {
          load: false,

          role: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.fetchDetail()
    },
    mounted () {
      
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`pos/company/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },
    }
  }
</script>